import React from 'react';

const FormField = ({ 
  label, 
  type = 'text', 
  name, 
  value, 
  onChange, 
  error, 
  options = [], 
  placeholder = '', 
  disabled = false,
  required = false,
  readOnly = false,
  children
}) => {
  
  if (type === 'select') {
    return (
      <div className="form-field">
        <label htmlFor={name}>{label} {required && <span className="required">*</span>}</label>
        <select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          className={error ? 'error' : ''}
          disabled={disabled}
          required={required}
        >
          <option value="">{placeholder || `Select ${label}`}</option>
          {options.map(option => {
            if (typeof option === 'string') {
              return <option key={option} value={option}>{option}</option>;
            } else {
              return <option key={option.value} value={option.value}>{option.label}</option>;
            }
          })}
        </select>
        {error && <span className="error-message">{error}</span>}
      </div>
    );
  }
  
  if (type === 'textarea') {
    return (
      <div className="form-field">
        <label htmlFor={name}>{label} {required && <span className="required">*</span>}</label>
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={error ? 'error' : ''}
          disabled={disabled}
          required={required}
          readOnly={readOnly}
        />
        {error && <span className="error-message">{error}</span>}
      </div>
    );
  }
  
  if (children) {
    return (
      <div className="form-field">
        <label htmlFor={name}>{label} {required && <span className="required">*</span>}</label>
        {children}
        {error && <span className="error-message">{error}</span>}
      </div>
    );
  }
  
  return (
    <div className="form-field">
      <label htmlFor={name}>{label} {required && <span className="required">*</span>}</label>
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={error ? 'error' : ''}
        disabled={disabled}
        required={required}
        readOnly={readOnly}
      />
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default FormField;